import { AxiosError } from 'axios';

interface ApiIssue {
  path: string;
  message: string;
}

interface ApiErrorBody {
  error?: {
    code?: string;
    message?: string;
    issues?: ApiIssue[];
  };
  message?: string;
}

export const getApiErrorMessage = (error: unknown, fallback: string) => {
  const axiosError = error as AxiosError<ApiErrorBody>;
  const body = axiosError.response?.data;
  const issues = body?.error?.issues;

  if (issues?.length) {
    return issues.map((issue) => issue.message).join('\n');
  }

  return body?.error?.message ?? body?.message ?? fallback;
};
